export default __webpack_public_path__ + "static/media/ten.614440a5.png";